<template>
  <child-button class="red"></child-button>
</template> 
<script setup>
import ChildButton from "@/components/ChildButton.vue";
</script> <style>
.red {
  color: red;
}
</style>